@let items = items$ | async;
@let contextNames = contextNames$ | async;
@let contextsByName = contextsByName$ | async;

<div class="wrapper">
  @for (contextName of contextNames; track contextName) {
    <div
      class="context-row"
      [style.grid-template-columns]="
        `130px repeat(${(columnCount$ | async)}, 200px)`
      "
    >
      <div class="sticky">{{ contextName }}</div>
      @for (
        contextByName of contextsByName;
        track contextByName;
        let i = $index
      ) {
        <h3-read-only-text-cell
          [itemId]="items![i].index"
          class="cell-value"
          [contextIndex]="contextByName[contextName]?.index"
        >
        </h3-read-only-text-cell>
      }
    </div>
  }
</div>
